import Layout from "../../../../src/components/layout";
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';
export default {
  Layout,
  getImage,
  GatsbyImage,
  React
};